import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { StatusResponse } from '../../../services/status.service';
import { ApproveResponse } from '../../../services/approve.service';
import { LoginService } from '../../../../login/services/login.service';

@Component({
  selector: 'ab-payment-complete',
  templateUrl: './payment-complete.component.html',
  styleUrls: ['./payment-complete.component.scss']
})
export class PaymentCompleteComponent implements OnInit, OnDestroy {
  @Input() merchantInfo: Partial<StatusResponse & ApproveResponse>;

  constructor(private loginService: LoginService) {}

  ngOnInit(): void {
    this.loginService?.logout().subscribe((response) => {});
  }

  redirectToMerchant() {
    if (window && window.location) {
      window.location.href =
        this.merchantInfo.url || this.merchantInfo.returnUrl || '';
    }
  }

  ngOnDestroy(): void {}
}
